import Http from "./http";

export const downloadAiCampaignSampleCsvAPI = () => {
  return Http.post("/admin/campaign/csv-template", {});
};
